import { HighlightedRecommendation } from '../../types';
import { HighlightedRecommendationCard } from '../../recommendations/highlighted-recommendation-card';
import BevSafeText from '../../bev-safe-text';

export const HighlightedRecommendationsComponent = ({
	sectionTitle,
	propertyRecommendation,
	ancilliaryRecommendation,
}: {
	propertyRecommendation?: HighlightedRecommendation;
	ancilliaryRecommendation?: HighlightedRecommendation;
	sectionTitle: string;
}) => {
	if (!propertyRecommendation && !ancilliaryRecommendation) {
		return null;
	}

	return (
		<div className="w-full flex flex-col gap-[20px]">
			<h2 className="text-h4 text-text-heading">
				<BevSafeText>{sectionTitle}</BevSafeText>
			</h2>
			<div className="w-full flex flex-col spacing-stack-l">
				<HighlightedRecommendationCard
					recommendation={propertyRecommendation}
					placement="for_you-highlighted_property"
					position={1}
				/>
				<HighlightedRecommendationCard
					recommendation={ancilliaryRecommendation}
					placement="for_you-highlighted_ancillary"
					position={2}
				/>
			</div>
		</div>
	);
};
